"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_shared_js_1 = require("@tableau/api-shared-js");
/**
 * Implementation of the external settings namespace.
 */
class Settings extends api_shared_js_1.EventListenerManager {
    constructor(_settingsImpl) {
        super();
        this._settingsImpl = _settingsImpl;
        // Initialize our event handling for this class
        this._settingsImpl.initializeEvents().forEach((e) => this.addNewEventType(e));
    }
    erase(key) {
        this._settingsImpl.erase(key);
    }
    get(key) {
        return this._settingsImpl.get(key);
    }
    getAll() {
        return this._settingsImpl.getAll();
    }
    get isModified() {
        return this._settingsImpl.isModified;
    }
    saveAsync() {
        return this._settingsImpl.saveAsync();
    }
    set(key, value) {
        this._settingsImpl.set(key, value);
    }
}
exports.Settings = Settings;
//# sourceMappingURL=Settings.js.map